<template>
  <el-container v-title data-title="读卡查询" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>考勤管理</el-breadcrumb-item>
                <el-breadcrumb-item>读卡查询</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form ref="searchForm" :inline="true" :model="searchForm" :rules="rules" class="demo-form-inline" >
                <el-form-item label="日期" :required="true" prop="date">
                  <el-date-picker
                    v-model="searchForm.date"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyyMMdd"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="卡号" :required="true" prop="cardNo">
                  <el-input v-model="searchForm.cardNo" placeholder="卡号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getReaderRecordList">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="recordTime" label="读卡时间" width="200"></el-table-column>
          <el-table-column prop="lineNo" label="位置编号" width="80"></el-table-column>
          <el-table-column prop="deviceName" label="设备名称" width="300"></el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      total: 0,
      searchForm: {
        date: new Date().toISOString().slice(0, 10).replace(/-/g, '')
      },
      rules: {
        date: [{ required: true, message: '请选择日期', trigger: 'blur' }],
        cardNo: [{ required: true, message: '请输入卡号', trigger: 'blur' }]
      },
      tableData: []
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    getReaderRecordList () {
      let _this = this
      this.$refs['searchForm'].validate((valid) => {
        if (valid) {
          _this.loading = true
          this.$axios.post(this.GLOBAL.host + '/attendence/getReaderRecordList',
            this.$qs.stringify({
              date: _this.searchForm.date,
              cardNo: _this.searchForm.cardNo
            })
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.tableData = res.data.data
              } else {
                this.$message.error(res.data.message)
              }
            }
            _this.loading = false
          })
        }
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/ReaderRecord.vue